export const buyflowUrlMap = {
  // Network Shop Banner CTA links
  'MGM+': [
    'https://www.spectrum.com/premium-channels/mgmplus?cmp=sspp_sod_gm_networks_mgmplus_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_networks_mgmplus_auth_050523',
  ],
  Cinemax: [
    'https://www.spectrum.com/premium-channels/cinemax?cmp=sspp_sod_gm_networks_cinemax_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_networks_cinemax_auth_050523',
  ],
  Max: [
    'https://www.spectrum.com/premium-channels/hbo?cmp=sspp_sod_gm_networks_hbomax_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels/review?packageId=419291&cid=sspp_sod_gm_networks_hbomax_auth_050523',
  ],
  Showtime: [
    'https://www.spectrum.com/premium-channels/showtime?cmp=sspp_sod_gm_networks_showtime_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_networks_showtime_auth_050523',
  ],
  STARZ: [
    'https://www.spectrum.com/premium-channels/starz?cmp=sspp_sod_gm_networks_starz_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_networks_starz_auth_050523',
  ],
  'STARZ ENCORE': [
    'https://www.spectrum.com/premium-channels/starz-encore?cmp=sspp_sod_gm_networks_starzencore_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_networks_starzencore_auth_050523',
  ],
  default: [
    'https://www.spectrum.com/cable-tv/plans?cmp=sspp_sod_gm_networks_shopspecplans_unauth_050523',
    'https://www.spectrum.net/change?cid=sspp_sod_gm_networks_shopspecplans_auth_050523',
  ],

  // Add network buyflow links in Hero Banner
  'https://www.spectrum.com/cable-tv/premium-channels/mgmplus?cmp=sod': [
    'https://www.spectrum.net/support/tv/spectrum-demand?cid=sspp_sod_gm_indvtshow_mgmplus_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_indvtvshow_mgmplus_auth_050523',
  ],
  'https://www.spectrum.com/premium-channels/cinemax.html?cmp=sod': [
    'https://www.spectrum.net/support/tv/spectrum-demand?cid=sspp_sod_gm_indvtshow_cinemax_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_indvtvshow_cinemax_auth_050523',
  ],
  'https://www.spectrum.com/premium-channels/hbo?cmp=sod': [
    'https://www.spectrum.net/support/tv/spectrum-demand?cid=sspp_sod_gm_indvtshow_hbomax_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels/review?packageId=419291&cid=sspp_sod_gm_indvtvshow_hbomax_auth_050523',
  ],
  'https://www.spectrum.com/premium-channels/showtime?cmp=sod': [
    'https://www.spectrum.net/support/tv/spectrum-demand?cid=sspp_sod_gm_indvtshow_showtime_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_indvtvshow_showtime_auth_050523',
  ],
  'https://www.spectrum.com/premium-channels/starz?cmp=sod': [
    'https://www.spectrum.net/support/tv/spectrum-demand?cid=sspp_sod_gm_indvtshow_starz_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_indvtvshow_starz_auth_050523',
  ],
  'https://www.spectrum.com/premium-channels/starz-encore?cmp=sod': [
    'https://www.spectrum.net/support/tv/spectrum-demand?cid=sspp_sod_gm_indvtshow_starzencore_unauth_050523',
    'https://www.spectrum.net/upgrade/tv/add-channels?cid=sspp_sod_gm_indvtvshow_starzencore_auth_050523',
  ],
};
